<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box no-display">
            <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>
            <v-toolbar flat class="toolbar" dense justify="center">
                <v-toolbar-title align="center">
                    <strong>
                        Installment Summary Report
                    </strong>
                </v-toolbar-title>
            </v-toolbar>
            <v-row dense justify="center">
                  <v-col cols="12" sm="3" md="3">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete rounded dense required color="#0F2027" v-model="org" :items="org_list" item-text="name" return-object label="Organization" outlined @click="clear()" @change="getAy()"></v-autocomplete>
                </v-col>
                     <v-col cols="12" sm="3" md="3">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete rounded dense required color="#0F2027" v-model="ay" :items="academic_year_list" item-text="ay" return-object label="Academic Year" @change="clear()" outlined></v-autocomplete>
                </v-col>
                     <v-col cols="12" sm="3" md="3">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete rounded dense required color="#0F2027" v-model="section" :items="section_list" item-text="section" return-object label="Section" @change="clear()" outlined></v-autocomplete>
                </v-col>
                <v-col cols="12" md="3" sm="3">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="status" :items="status_list" item-text="name" item-value="id" label="Status"  @change="clear()" outlined persistent-hint hint="Select Status" />
                </v-col>
                 <v-col cols="12" sm="2" md="2" v-if="ay && org && section && status">
                    <v-btn class="mt-6 button" @click="getreport()">Fetch / Generate</v-btn>
                </v-col>
            </v-row>
        </v-card>
        <span v-if="show == true">
            <installment-fee-detailed-report></installment-fee-detailed-report>
        </span>
    </div>
</template>
<script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    import InstallmentFeesDetailReport from "./InstallmentFeesDetailReport";
    export default {
        components:{
            "installment-fee-detailed-report":InstallmentFeesDetailReport
        },
        data() {
            return {
                all_toggle: false,
                loader: false,
                overlay: false,
                color: "",
                snackbar: false,
                search: null,
                snackbar_msg: null,
                fees_structure_data: null,
                current_academic_year: null,
                stream: null,
                header: null,
                standard_list: null,
                dision_list: null,
                org_list: null,
                display_data: false,
                org_data_list: [],
                division_list: [],
                dialog: false,
                org_data: [],
                fetch_loader: false,
                header_list: [],
                org:null,
                show:false,
                std_id:null,
                sem_id:null,
                sem_list:[],
                ay:null,
                academic_year_list: null,
                stud_list:[],
                registration_no:null,
                section_list:[],
                section:null,
                status_list: [
                    { name: "Active", id: "0" },
                    { name: "Temporary Inactive", id: "1" },
                    { name: "Permanent Inactive", id: "2" },
                ],
                status: null,
            };
        },
        watch: {
        
        },
        methods: {
             getreport() {
                // this.$store.commit("setay", this.ay.ay_id);
                // this.$store.commit("setsection", this.section.id);
                // this.$store.commit("setorg", this.org.id);
                localStorage.setItem("setay", this.ay.ay_id);
                localStorage.setItem("setsection", this.section.id);
                localStorage.setItem("setorg", this.org.id);
                localStorage.setItem("setstatus", this.status);
                this.show = true;
             },
            clear() {
                this.org_data_list = [];
                this.show=false
            },
            getAy() {
                this.ay = null,
                this.section = null,
                this.academic_year_list =[],
                this.section_list = []
                const data = {
                    org: this.org.id,
                };
                axios
                    .post("/Management/getAy", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.academic_year_list = res.data.academic_year_list;
                          //  this.standard_list = res.data.standard_list;
                            this.section_list = res.data.section_list
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!");
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong!");
                    })
                    .finally(() => {
                        //close loader
                    });
            },
           
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            onload() {
                axios
                    .post("/Management/getOrg_without_all")
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.org_list = res.data.org_list;
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong!");
                    })
                    .finally(() => {
                        //close loader
                    });
            },
        },
        mounted() {
            this.onload();
        },
    };
</script>
<style scoped>
    .mytable /deep/ thead th {
        background: #0f2027 !important; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }
    .btn-css {
        outline: 0 !important;
        outline-offset: 0 !important;
        background-image: none !important;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        background-color: #fff !important;
        text-decoration: underline;
        color: #0f2027 !important;
        text-align: center;
    }

    .btn-css:hover {
        outline: 0 !important;
        outline-offset: 0 !important;
        background-image: none !important;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        background-color: #ffff !important;
        color: #0f2027 !important;
        text-decoration: underline;
        text-align: center;
    }
    tr,
    td,
    th {
        border: 1px solid #ccc;
        text-align: center;
        font-size: small;
    }
    tr,
    tbody {
        border-bottom: 1px solid #ccc;
        border: 1px solid #ccc;
        font-size: small;
    }
    td {
        margin: 0.3rem !important;
        padding: 0.4rem !important;
        font-size: small;
    }
    @media (min-width: 320px) {
        td,
        th {
            display: table-cell !important;
            font-size: small;
        }
        td + td,
        th + th {
            width: auto;
            font-size: small;
        }
    }
    v-simple-table {
        white-space: nowrap !important;
        text-align: center;
        font-size: small;
    }
    @media print {
    
        .no-display,
        .v-input__control,
        input[type="button"],
        input[type="submit"],
        input[type="reset"],
        #v-card {
            display: none !important;
        }
       
    }
</style>
